// Signup / app lives on the dev subdomain — it handles auth and everything
// post-signup. The marketing site just drives users there.
export const SIGNUP_URL = 'https://dev.tanrenai.com';

// Public-facing support contact. Update if the real inbox differs.
export const SUPPORT_EMAIL = 'support@tanrenai.com';

// Open-source repo — bug reports, feature requests, discussions.
export const GITHUB_REPO = 'https://github.com/ThatCatDev/tanrenai';
